import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {useShowError} from '@hooks/useShowError/useShowError'
import {QUERY_KEY_DEVICE_RECORDINGS} from '@containers/monitoringPlatform/geoZones/queryHooks/constants/queryKey'
import {getDeviceRecordingsByPeriodApi} from '@containers/monitoringPlatform/geoZones/api/api'

interface IProps {
	accountId: number
	deviceId: number
	dateFrom: string
	dateTo: string
	enabled: boolean
	singleVoyage?: boolean
}

export const useGetDeviceRecordingsByPeriodQuery = ({
	accountId,
	deviceId,
	dateFrom,
	dateTo,
	enabled,
	singleVoyage = false,
}: IProps) => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getDeviceRecordingsByPeriodApi({accountId, deviceId, dateFrom, dateTo, singleVoyage}, onShowError),
		queryKey: [QUERY_KEY_DEVICE_RECORDINGS, accountId?.toString(), deviceId?.toString(), dateFrom, dateTo, singleVoyage],
		staleTime: 1000 * 60 * 5,
		enabled: enabled && !!accountId && !!deviceId && !!dateFrom && !!dateTo,
		placeholderData: keepPreviousData,
	})
}
